/**
 *
 * @module entry
 * @desc {SDK.Services.Identity.Bam} entry point.
 *
 */

import AuthenticationFlow from './authenticationFlow';
import AuthenticationFlowResponse from './authenticationFlowResponse';
import BamIdentityClient from './bamIdentityClient';
import BamIdentityClientConfiguration from './bamIdentityClientConfiguration';
import BamIdentityClientEndpoint from './bamIdentityClientEndpoint';
import Identity from './identity';
import OneTimePasscodeRequestReason from './oneTimePasscodeRequestReason';
import RedeemedPasscodeToken from './redeemedPasscodeToken';

/**
 *
 * @typedef SDK.Services.Identity.Bam
 * @type {Object}
 *
 * @property {AuthenticationFlow} AuthenticationFlow
 * @property {AuthenticationFlowResponse} AuthenticationFlowResponse
 * @property {BamIdentityClient} BamIdentityClient
 * @property {BamIdentityClientConfiguration} BamIdentityClientConfiguration
 * @property {BamIdentityClientEndpoint} BamIdentityClientEndpoint
 * @property {Identity} Identity
 * @property {OneTimePasscodeRequestReason} OneTimePasscodeRequestReason
 * @property {RedeemedPasscodeToken} RedeemedPasscodeToken
 *
 */

/**
 *
 * @type {SDK.Services.Identity.Bam}
 *
 */
export default {

    AuthenticationFlow,
    AuthenticationFlowResponse,
    BamIdentityClient,
    BamIdentityClientConfiguration,
    BamIdentityClientEndpoint,
    Identity,
    OneTimePasscodeRequestReason,
    RedeemedPasscodeToken

};



// WEBPACK FOOTER //
// ./src/services/identity/bam/entry.js